/* eslint-disable no-unused-vars */
export enum TriggerType {
    TIMEOUT = 'timeout',
    WRONG_ANSWER = 'wrong_answer',
    CORRECT_ANSWER = 'correct_answer',
    TRANSITION = 'transition',
    ATTEMPTS = 'attempts',
}
